module.exports = __webpack_public_path__ + "img/toggle.413e24a4.svg";